function calculate_subsidy_percentage(family_income) {
    if (family_income <= 83280) {
        return 90;
    } else if (family_income > 83280) {
        return (90 - ((family_income - 83280) / 5000));
    } else {
        return 0;
    }
}

function calculate_subsidy_percentage_second_or_younger(family_income) {
    if (family_income <= 141321) {
        return 95;
    } else if (family_income > 141321 && family_income < 186321) { //DS 95
        return (95 - ((family_income - 141321) / 3000))
    } else if (family_income >= 186321 && family_income < 265611) { //80
        return 80;
    } else if (family_income >= 265611 && family_income < 355611) { //DS 80
        return (80 - ((family_income - 265611) / 3000))
    } else if (family_income >= 355611 && family_income < 365611) { //50
        return 50;
    } else {
        return 0;
    }
}

function max_ccs_hour_claim(activity_hour, income) {
    if (activity_hour <= 7 && income <=83280) {
        return 12;
    } else if (activity_hour >= 8 && activity_hour <= 16) {
        return 18;
    } else if (activity_hour >= 17 && activity_hour <= 48) {
        return 36;
    } else if (activity_hour >= 49) {
        return 50;
    } else {
        return 0;
    }
}

function standard_calculator(daily_fee, number_days, number_hours, income, activity_hour) {
    var hourly_fee = (daily_fee / number_hours);
    if (hourly_fee >= 14.29) { //if daily hourly cap is over $14.29
        hourly_fee = 14.29;
    }

    var ccs_percent = ((calculate_subsidy_percentage(income)) / 100);

    var max_ccs_hour_can_claim = max_ccs_hour_claim(activity_hour, income);
    var total_weekly_hours = (number_days * number_hours);
    if (total_weekly_hours > max_ccs_hour_can_claim) {
        total_weekly_hours = max_ccs_hour_can_claim;
    }

    var weekly_rebate = (total_weekly_hours * ccs_percent * hourly_fee);


    console.log({
        daily_fee: daily_fee,
        hourly_fee: hourly_fee,
        ccs_percent: ccs_percent,
        max_ccs_hour_can_claim: max_ccs_hour_can_claim,
        total_weekly_hours: total_weekly_hours,
        weekly_rebate: weekly_rebate
    }); 

    return {
        weekly_fee: Math.round((daily_fee * number_days) * 100) / 100,
        rebate: Math.round(weekly_rebate * 100) / 100,
        ccs_witholding: Math.round((weekly_rebate * 0.05) * 100) / 100,
        percent: (ccs_percent * 100).toFixed(2)
    };
}


function second_child_calculator(daily_fee, number_days, number_hours, income, activity_hour) {
    var hourly_fee = (daily_fee / number_hours);
    if (hourly_fee >= 14.29) { //if daily hourly cap is over $14.29
        hourly_fee = 14.29;
    }

    var ccs_percent = ((calculate_subsidy_percentage_second_or_younger(income)) / 100);

    var max_ccs_hour_can_claim = max_ccs_hour_claim(activity_hour, income);
    var total_weekly_hours = (number_days * number_hours);
    if (total_weekly_hours > max_ccs_hour_can_claim) {
        total_weekly_hours = max_ccs_hour_can_claim;
    }

    var weekly_rebate = (total_weekly_hours * ccs_percent * hourly_fee);

    console.log({
        daily_fee: daily_fee,
        hourly_fee: hourly_fee,
        ccs_percent: ccs_percent,
        max_ccs_hour_can_claim: max_ccs_hour_can_claim,
        total_weekly_hours: total_weekly_hours,
        weekly_rebate: weekly_rebate
    }); 

    return {
        weekly_fee: Math.round((daily_fee * number_days) * 100) / 100,
        rebate: Math.round(weekly_rebate * 100) / 100,
        ccs_witholding: Math.round((weekly_rebate * 0.05) * 100) / 100,
        percent: (ccs_percent * 100).toFixed(2)
    };
}

function calculate_subsidy_weekly(daily_fee, number_days, number_hours, income, activity_hour, age, ages, ageOverFive, index) {
    console.log ('calc age', age);
    console.log ('calc ages', ages);
    console.log ('calc ageOverFive', ageOverFive);
    if (income >= 365611) {
        return standard_calculator(daily_fee, number_days, number_hours, income, activity_hour);
    } else {
        // Find eldest
        var largest = ages[0];
        for (var i = 0; i < ages.length; i++) {
            if (largest < ages[i] ) {
                largest = ages[i];
            }
        }
        console.log ('calc largest', largest);
        if ((ageOverFive && age >= 5) || ages.length === 1) {
            return standard_calculator(daily_fee, number_days, number_hours, income, activity_hour);
        } else if (age === largest && firstLargest) {
            firstLargest = false;
            return standard_calculator(daily_fee, number_days, number_hours, income, activity_hour);
        } else {
            return second_child_calculator(daily_fee, number_days, number_hours, income, activity_hour);
        }        
    }
}

var extra_day_activated = false;
var firstLargest;
var calc_centre, fee_json;
var annual_cap_income = 189390;
var ccs_master_res = [];
var ccs_master_res_extra_days = [];
var centre_info_array =[];
var $result = $("#result");
var ccs_result_template = $("#ccs_result_template").html();
var ccs_result_plus1_template = $("#ccs_result_plus1_template").html();
var ccs_total_result_template = $("#ccs_total_result_template").html();
var select_centre_template = $("#select_centre_template").html();
var dob_template = $("#dob_template").html();
var days_per_week_template = $("#days_per_week_template").html();
var centre_information_template = $("#centre_information_template").html();
Mustache.parse(ccs_result_template);
Mustache.parse(ccs_result_plus1_template);
Mustache.parse(ccs_total_result_template);
Mustache.parse(select_centre_template);
Mustache.parse(dob_template);
Mustache.parse(days_per_week_template);
Mustache.parse(centre_information_template);

$("#calc_form").on("change", "input,select", function () {
	extra_day_activated = false;
	$("#additional-care").attr("style", "display: none;");
	$("#additional-care1").attr("style", "display: none;");
	$('[id^=summary_plus1]').hide();
				
	var num_child = $('input[name=num_child]:checked').val();
	$("#result_summary").html("");
	$("#total_ccs").html("");
	var number_hours = 0;
	var income = $("#income").val();
	var activity_hour = $("#hours").val();
	var master_out_pocket = 0;
	var master_weekly = 0;
	var centre_ids = [];
	ccs_master_res = [];
	ccs_master_res_extra_days = [];

	var ages = [];
	var ageOverFive = false;
	for (var x = 1; x <= num_child; x++) {
		var dob_input = $('input[type=text][name=child_dob_' + x + ']').val();

		if (dob_input) {
			var converted_age = getAge(dob_input);
			console.log('converted_age  ', converted_age);
			if (converted_age > -1) {
				if (converted_age >= 5) {
					ageOverFive = true;
				}
				ages.push(converted_age);
				console.log('ages ', ages);
			} else {
				console.log ('error converted ', getAge(dob_input));
			}
		} else {
			console.log('error input ', $('input[type=text][name=child_dob_' + x + ']').val());
		}
	}
	firstLargest = true;
	for (var i = 1; i <= num_child; i++) {
		var dob = $('input[type=text][name=child_dob_' + i + ']').val();
		var centre_id = $('select[name=child_centre_' + i + ']').val();
        var number_days = parseInt($('select[name="child_days_' + i + '"]').val());

		if (number_days < 5) {
			$("#additional-care").attr("style", "display: block;");
		}

		if (number_days > 5 || number_days < 1) { //Def set to 5 if value is imporper
			number_days = 5;
		}

		var weekly_rebate = 0;
		var weekly_rebate_plus1 = 0;
		$("#result .annual_cap_text").hide();

		if (centre_id && number_days && income && activity_hour) {
				var centre_obj = ($.grep(fee_json, function (e) {
				return e.id == centre_id;
			}))[0];
			var cc_centre_name = centre_obj["name"];

			if (number_days >= 5) {
				number_hours = 10;
			} else {
				number_hours = centre_obj["hours"];
			}
	
			var age = getAge(dob);
			var fee = "fee1";
			if (age < 2) {
				fee = "fee1";
			} else if (age < 4) {
				fee = "fee2";
			} else {
				fee = "fee3";
			}
			weekly_rebate = calculate_subsidy_weekly(centre_obj[fee], number_days, number_hours, income, activity_hour, age, ages, ageOverFive, i);
			if (weekly_rebate) {
				weekly_rebate.id = i;
				weekly_rebate.centre_id = centre_id;
				weekly_rebate.cc_centre_name = cc_centre_name;
				weekly_rebate.number_days = number_days;
				//has subsidy
				console.log(weekly_rebate);
				var annual_cap = false;
				if (income >= annual_cap_income && income <= 353680) {
					annual_cap = true;
				}
				master_weekly += weekly_rebate.rebate - weekly_rebate.ccs_witholding;
				master_out_pocket += weekly_rebate.weekly_fee - (weekly_rebate.rebate - weekly_rebate.ccs_witholding);
				centre_ids.push(centre_obj["post_id"]);
				ccs_master_res.push(weekly_rebate);
				$("#result_summary").append(
					Mustache.render(ccs_result_template, {
						child_num: i,
						centre_name: centre_obj["name"],
						total_fees_weekly: weekly_rebate.weekly_fee.toFixed(2),
						total_fees_fortnightly: (weekly_rebate.weekly_fee * 2).toFixed(2),
						total_ccs_fees_weekly: (weekly_rebate.rebate - weekly_rebate.ccs_witholding).toFixed(2),
						total_ccs_fees_fortnightly: ((weekly_rebate.rebate - weekly_rebate.ccs_witholding) * 2).toFixed(2),
						total_ccs_witholding_weekly: weekly_rebate.ccs_witholding.toFixed(2),
						total_ccs_witholding_fortnightly: (weekly_rebate.ccs_witholding * 2).toFixed(2),
						estimated_costs_weekly: (weekly_rebate.weekly_fee - (weekly_rebate.rebate - weekly_rebate.ccs_witholding)).toFixed(2),
						estimated_costs_fortnightly: ((weekly_rebate.weekly_fee - (weekly_rebate.rebate - weekly_rebate.ccs_witholding)) * 2).toFixed(2),
						annual_cap: annual_cap,
						percent: weekly_rebate.percent,
						number_days: number_days + " days"
					})
				);

				if (number_days < 5) {
					weekly_rebate_plus1 = calculate_subsidy_weekly(centre_obj[fee], number_days + 1, number_hours, income, activity_hour, age, ages, ageOverFive, i);
				
					weekly_rebate_plus1.id = i;
					weekly_rebate_plus1.centre_id = centre_id;
					weekly_rebate_plus1.cc_centre_name = cc_centre_name;
					weekly_rebate_plus1.number_days = number_days;
					weekly_rebate_plus1.initial_weekly_fee = weekly_rebate.weekly_fee;
					weekly_rebate_plus1.initial_rebate = weekly_rebate.rebate;
					weekly_rebate_plus1.initial_ccs_witholding = weekly_rebate.ccs_witholding;
					weekly_rebate_plus1.initial_percent = weekly_rebate.percent;
					ccs_master_res_extra_days.push(weekly_rebate_plus1);
					$("#result_summary").append(
						Mustache.render(ccs_result_plus1_template, {
							child_num: i,
							centre_name: centre_obj["name"],
							
							total_fees_weekly: weekly_rebate.weekly_fee.toFixed(2),
							total_fees_fortnightly: (weekly_rebate.weekly_fee * 2).toFixed(2),
							total_ccs_fees_weekly: (weekly_rebate.rebate - weekly_rebate.ccs_witholding).toFixed(2),
							total_ccs_fees_fortnightly: ((weekly_rebate.rebate - weekly_rebate.ccs_witholding) * 2).toFixed(2),
							total_ccs_witholding_weekly: weekly_rebate.ccs_witholding.toFixed(2),
							total_ccs_witholding_fortnightly: (weekly_rebate.ccs_witholding * 2).toFixed(2),
							estimated_costs_weekly: (weekly_rebate.weekly_fee - (weekly_rebate.rebate - weekly_rebate.ccs_witholding)).toFixed(2),
							estimated_costs_fortnightly: ((weekly_rebate.weekly_fee - (weekly_rebate.rebate - weekly_rebate.ccs_witholding)) * 2).toFixed(2),
							
							total_fees_weekly_plus1: weekly_rebate_plus1.weekly_fee.toFixed(2),
							total_fees_fortnightly_plus1: (weekly_rebate_plus1.weekly_fee * 2).toFixed(2),
							total_ccs_fees_weekly_plus1: (weekly_rebate_plus1.rebate - weekly_rebate_plus1.ccs_witholding).toFixed(2),
							total_ccs_fees_fortnightly_plus1: ((weekly_rebate_plus1.rebate - weekly_rebate_plus1.ccs_witholding) * 2).toFixed(2),
							total_ccs_witholding_weekly_plus1: weekly_rebate_plus1.ccs_witholding.toFixed(2),
							total_ccs_witholding_fortnightly_plus1: (weekly_rebate_plus1.ccs_witholding * 2).toFixed(2),
							estimated_costs_weekly_plus1: (weekly_rebate_plus1.weekly_fee - (weekly_rebate_plus1.rebate - weekly_rebate_plus1.ccs_witholding)).toFixed(2),
							estimated_costs_fortnightly_plus1: ((weekly_rebate_plus1.weekly_fee - (weekly_rebate_plus1.rebate - weekly_rebate_plus1.ccs_witholding)) * 2).toFixed(2),
							
							
							annual_cap: annual_cap,
							percent: weekly_rebate.percent,
							number_days: number_days + " days",
							number_days_plus1: (number_days + 1) + " days"
						})
					);
					
				}
				$('[id^=summary_plus1]').hide();
			}
		} else {
			//do nothing
		}
	}
	var unique_ids = [];
	$.each(centre_ids, function(i, el){
		if($.inArray(el, unique_ids) === -1) unique_ids.push(el);
	});
	$("#centre_information").html(
		Mustache.render(centre_information_template, {
			centres: Get_Centre_Info_Array(unique_ids)
		})
	);

	$("#total_ccs").html(
		Mustache.render(ccs_total_result_template, {
			total_ccs_fees_weekly: master_weekly.toFixed(2),
			total_ccs_fees_fortnightly: (master_weekly * 2).toFixed(2),
			estimated_costs_weekly: master_out_pocket.toFixed(2),
			estimated_costs_fortnightly: (master_out_pocket * 2).toFixed(2)
		})
	);
	if (master_weekly > 0) {
		$result.children(".calculating").slideUp(
			300, "swing",
			function () {
				$result.children(".result").slideDown();
			}
		);
        $('#result .calculating').hide();
	} 
});

$("a.calc_trigger").click(function (e) {
	e.preventDefault(); //Do Nothing
    $('#result .calculating').show();
	jump("result");
});


$("a.js-add-one-day-btn").click(function (e) {
	e.preventDefault(); //Do Nothing

	var elms2 = document.querySelectorAll("[id='summary_default']");
	for(var i = 0; i < elms2.length; i++) {
		console.log("dataset -", elms2[i].dataset.days);
		console.log("dataset -", parseInt(elms2[i].dataset.days));
		if (parseInt(elms2[i].dataset.days) < 5) {
			elms2[i].style.display='none';
		}
	}
	$('[id^=summary_plus1]').attr("style", "display: flex;");
	
	$("#additional-care").attr("style", "display: none;");
	$("#additional-care1").attr("style", "display: block;");
	extra_day_activated = true;
	jump("result");
});


$("a.js-applied-btn").click(function (e) {
	e.preventDefault(); //Do Nothing

	var elms2 = document.querySelectorAll("[id='summary_default']");
	for(var i = 0; i < elms2.length; i++) {
		console.log("dataset -", elms2[i].dataset.days);
		console.log("dataset -", parseInt(elms2[i].dataset.days));
		if (parseInt(elms2[i].dataset.days) < 5) {
			elms2[i].style.display='flex';
		}
	}
	$('[id^=summary_plus1]').attr("style", "display: none;");
	
	$("#additional-care").attr("style", "display: block;");
	$("#additional-care1").attr("style", "display: none;");
	extra_day_activated = false;

	jump("result");
});

function jump(h){
    var url = location.href;               //Save down the URL without hash.
    location.href = "#"+h;                 //Go to the target element.
    history.replaceState(null,null,url);   //Don't like hashes. Changing it back.
}

function getAge(dateString) 
{	
	console.log('dateString ', dateString);
	var ageInYears = moment().diff(moment(dateString, "DD-MM-YYYY"), 'years');
	console.log('ageInYears', ageInYears);
	return ageInYears;
}


function loadCentresAndFees() {
	var fees_url = location.origin + "/wp-content/themes/guardian-elg-child-2019/js/json/fees.json?v=" + Math.floor(Date.now() / 1000);
	$.get(fees_url, function (data) {
		fee_json = data;
		fee_json.sort(function(a, b){
			var a1= a.name.toLowerCase(), b1= b.name.toLowerCase();
			if(a1== b1) return 0;
			return a1> b1? 1: -1;
		});
		Add_Child_And_Centres(1, fee_json);
	});
}

//select 
function Add_Child_And_Centres(child_num, centres) {
	var child_dob = "";
	var child_centre = "";
	var days_per_week = "";
	for (var i = 1; i <= child_num; i++) {
		child_dob += Mustache.render(dob_template, {
			num: i,
			name: "child_dob_" + i,
		});
		child_centre += Mustache.render(select_centre_template, {
			num: i,
			name: "child_centre_" + i,
			centres: centres
		});
		//days_per_week_template
		days_per_week += Mustache.render(days_per_week_template, {
			num: i,
			name: "child_days_" + i,
		});
	}
	$("#child_dob").html(child_dob);
	$("#child_centre").html(child_centre);
	$("#days_per_week").html(days_per_week);
	$(".select2").select2({
		tags: true,
	});
	/*
	$.each(centres, function (i, el) {
		$("#select_centre").append("<option value=\"" + el.id + "\">" + el.name + "</option>");
	}); */
}

function Get_Centre_Info_Array(centre_post_ids) {
	var centres_info = [];
	$.each(centre_post_ids, function( index, item ) {
		centres_info.push(
			$.grep(centre_info_array, function (e) {
				return e.post_id == item;
			})[0]
		);
	});
	return centres_info;
}

$(window).load(function () {
	loadCentresAndFees();
	$('input[type=radio][name=num_child]').change(function () {
		Add_Child_And_Centres(this.value, fee_json);
		$(".js-bootstrap-datepicker").each(function (index, element) {
			$(element).datepicker({
				startDate: $(element).data("dp-min"),
				endDate: $(element).data("dp-max"),
				startView: $(element).data("dp-view"),
				format: "dd-mm-yyyy",
				autoclose: true
			});
		});
	});
	$.get(location.origin + "/wp-content/themes/guardian-elg-child-2019/js/json/centres.json?v=" + Math.floor(Date.now() / 1000), function (data) {
		centre_info_array = data;
	});
});

$("#ccs_email_form").submit(function (e) {
	e.preventDefault();
	var post_data = objectifyForm($(this).serializeArray());
	post_data["action"] = "ccs_email_form_submit";
	post_data["extra_day_activated"] = extra_day_activated;
	if (extra_day_activated == true) {
		for(var i = 0, l = ccs_master_res.length; i < l; i++) {
			for(var j = 0, ll = ccs_master_res_extra_days.length; j < ll; j++) {
				if(ccs_master_res[i].id === ccs_master_res_extra_days[j].id) {
					ccs_master_res.splice(i, 1, ccs_master_res_extra_days[j]);
					break;
				}
			}
		}
		post_data["rebate_arr"] = ccs_master_res;
	} else {
		post_data["rebate_arr"] = ccs_master_res;
	}
	post_data["post_id"] = 27018;
	post_data["full_name"] = post_data["full_name"].trim().split(/(\s+)/)[0];
	post_data["source"] = $("#ccs_email_form").attr("data-source");
	$("#ccs_email_form .js-ccs-email-btn")
	.addClass("btn-disabled")
	.html("<div class=\"spinner white\"><div class=\"dot1\"></div><div class=\"dot2\"></div></div> Submitting...");
	$.ajax({
		url: ajaxurl,
		method: "POST",
		data: post_data,
		dataType: "json",
		success: function (data) {
			console.log(data);
			if ("success" in data && data.success) {
				GA_Send_Event("ccs", "email-lead", data.res_id);
				GA_Send_Event("LeadType", "ccs_page_brand_new_" + data.brand_new_lead , data.res_id);
				fbq("track", "ccs-email-lead", {
					content_name: data.res_id
				}, {eventID: 'ccs-email-lead_' + data.res_id });
				fbq("track", "LeadType", { 
					content_category: "ccs_page_brand_new_" + data.brand_new_lead
				}, {eventID: 'LeadType_' + data.res_id});
				$("#ccs_email_results_wrap").html("<h3 class=\"green center\">Thank you for providing your information, we've successfully sent you an email with your Estimated CCS Results.</h3>");
			} else {
				GA_Send_Event("ccs", "email-lead", "Submission Error");
				if (typeof Rollbar !== "undefined") {
					Rollbar.error("CCS Email SUBMISSION Error", post_data);
				}
				$("#ccs_email_results_wrap").html("<h3 class=\"orange center\">We're sorry! There was an issue submitting your details - please try again. If this issue persists, please contact us on 138230.</h3>");
			}
		},
		error: function (xhr, code, error) {
			console.log(error);
			GA_Send_Event("ccs", "ccs-email-lead", "Submission Error XHR");
			if (typeof Rollbar !== "undefined") {
				Rollbar.error("CCS Email SUBMISSION Error XHR", post_data);
			}
			$("#ccs_email_results_wrap").html("<h3 class=\"orange center\">We're sorry! There was an issue submitting your details - please try again. If this issue persists, please contact us on 138230.</h3>");
		},
		complete: function () {}
	});
});